var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-container',{attrs:{"id":"release-notes-container"}},[(_vm.isLoading)?_c('jz-spinner'):_vm._e(),(_vm.noResults)?_c('jz-container',{staticClass:"empty-release-notes",attrs:{"flex":"","fill":""}},[_vm._v(" "+_vm._s(_vm._f("__")("release-notes.empty"))+" ")]):_vm._e(),_vm._l((_vm.releaseNotes),function(ref){
var id = ref.id;
var body = ref.body;
var release_date = ref.release_date;
var title = ref.title;
var version = ref.version;
var scope = ref.scope;
return _c('div',{key:id},[_c('release-note-card',{attrs:{"release-title":title,"release-version":version,"release-date":release_date,"markdown-content":body,"scope":scope}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }